<template>
  <div />
</template>

<script>
  import {mapGetters} from 'vuex'

  export default {
    name: 'TrackerYandexMetrika',
    computed: {
      ...mapGetters(['config']),
      isEnabled() {
        return this.config.tracking && this.config.yandexMetrika
      },
    },
    watch: {
      isEnabled: {
        immediate: true,
        handler() {
          if (this.isEnabled) {
            this.init()
          } else {
            this.destroy()
          }
        },
      }
    },
    methods: {
      init() {
        if (!window.ym && this.isEnabled) {
          (function(m,e,t,r,i,k,a){m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)}; m[i].l=1*new Date();k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)}) (window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym"); window.ym(this.config.yandexMetrika, "init", { clickmap:false, trackLinks:true, accurateTrackBounce:true, webvisor:false });
        }
      },
      track(goal, params) {
        if (window.ym && this.isEnabled) {
          window.ym(this.config.yandexMetrika, 'reachGoal', goal, params)
        }
      },
      destroy() {

      },
    },
    created() {
      this.$store.subscribeAction(({type, payload}) => {
        if (type === 'goal') {
          this.track(payload.goal, payload.params)
        }
      })
    },
    beforeDestroy() {
      this.destroy()
    },
  }
</script>
